/**
 * @memberOf Tee
 * @public
 * @class Represents an X,Y point.
 * @param {number} x Horizontal point position.
 * @param {number} y Vertical point position.
 */
export class Point {
	constructor(x, y) {
		this.x = x
		this.y = y
	}
}

/**
 * @memberOf Tee
 * @public
 * @class Represents a rectangle with origin xy position, width and height.
 * @param {number} x The position of left side of rectangle.
 * @param {number} y The position of top side of rectangle.
 * @param {number} width Amount of rectangle width.
 * @param {number} height Amount of rectangle height.
 */
export class Rectangle {
	constructor(x, y, width, height) {
		this.x = x
		this.y = y
		this.width = width
		this.height = height
	}

	set(x, y, width, height) {
		this.x = x
		this.y = y
		this.width = width
		this.height = height
	}

	setFrom(r) {
		this.x = r.x
		this.y = r.y
		this.width = r.width
		this.height = r.height
	}

	getRight() {
		return this.x + this.width
	}

	getBottom() {
		return this.y + this.height
	}

	setTop(value) {
		this.height -= value - this.y
		this.y = value
	}

	setBottom(value) {
		this.height = value - this.y
	}

	setLeft(value) {
		this.width -= value - this.x
		this.x = value
	}

	setRight(value) {
		this.width = value - this.x
	}

	contains(p) {
		return p.x >= this.x && p.x <= this.x + this.width && p.y >= this.y && p.y <= this.y + this.height
	}

	offset(x, y) {
		this.x += x
		this.y += y
	}
}
